var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpAndDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9972 14.5875V5C14.9972 4.45 15.4468 4 15.9962 4C16.5457 4 16.9952 4.45 16.9952 5V14.5875L19.2992 12.3013C19.6888 11.9113 20.3182 11.9113 20.7078 12.3013C21.0974 12.6913 21.0974 13.3213 20.7078 13.7113L16.6955 17.7075C16.3059 18.0975 15.6766 18.0975 15.287 17.7075L11.2922 13.7087C10.9026 13.3187 10.9026 12.6887 11.2922 12.2987C11.6818 11.9087 12.3212 11.9087 12.7108 12.2987L14.9972 14.5875Z",
    fill: "#04B7EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00275 7.4125L7.00275 17C7.00275 17.55 6.5532 18 6.00376 18C5.45431 18 5.00476 17.55 5.00476 17L5.00476 7.4125L2.70079 9.69875C2.31118 10.0887 1.68181 10.0887 1.29221 9.69875C0.902598 9.30875 0.902598 8.67875 1.29221 8.28875L5.30446 4.2925C5.69407 3.9025 6.32343 3.9025 6.71304 4.2925L10.7078 8.29127C11.0974 8.68127 11.0974 9.31127 10.7078 9.70127C10.3182 10.0913 9.67883 10.0913 9.28922 9.70127L7.00275 7.4125Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpAndDownIcon);
export default __webpack_public_path__ + "static/media/ArrowUpAndDownIcon.bf4807d9b250afacfe46baecfb684efc.svg";
export { ForwardRef as ReactComponent };